import { number } from './number';

export const formatMoneyDisplayType = (number: number) => {
    if (number === 0) {
        return '0,000';
    } else {
        return number.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    }
};

export const formatNumberMoney = (n: number) => {
    n = number(n);
    return (
        n?.toFixed(0).replace(/./g, function (c, i, a) {
            return i > 0 && c !== '.' && (a.length - i) % 3 === 0 ? ',' + c : c;
        }) || 0
    );
};
